module.exports = "data:image/gif;base64,R0lGODlhEAAQAKIAAAAAAP///wD/AACEAMbexqWlpf///wAAACH5BAEAAAYALAAAAAAQABAAAAMiaLrc/jDKRsZUtVwz9B3WFz6dAkbFCXoQ6IqjtG4GS99RAgA7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/approved.gif
// module id = LMHm
// module chunks = 1